import { ServiceType } from '../../../enums/contractor';
import { CommercialSpaceType, ExperienceType } from '../../../enums/experience';
import { FormValues as Experience } from '../../../types/experience';

export type AvailableOptionalService = {
    description: string;
    serviceType: ServiceType;
};

export function shouldShowOptionalServicesSection(
    experience: Experience,
    reservation: any,
): boolean {
    const ownerHasBlockedServices =
        reservation?.bookerType === 'owner' && reservation?.onBehalf === false;

    const hasContractors = (experience?.contractors.length ?? 0) > 0;
    const hasSetMenus = (experience?.setMenus.length ?? 0) > 0;

    const hasAnyService =
        (experience?.details?.type === ExperienceType.Property &&
            (experience?.details?.catering ||
                experience?.details?.alcohol ||
                experience?.details?.massages)) ||
        (experience?.details?.type === ExperienceType.Boat &&
            (experience?.details?.catering || experience?.details?.alcohol)) ||
        (experience?.details?.type === ExperienceType.Commercial &&
            experience?.details?.catering);

    if (
        ownerHasBlockedServices ||
        (!hasContractors && !hasSetMenus && !hasAnyService)
    ) {
        return false;
    }

    if (
        experience?.type === ExperienceType.Property ||
        experience?.type === ExperienceType.Boat
    ) {
        return true;
    }

    if (
        experience?.type === ExperienceType.Commercial &&
        (reservation?.bookingInfo?.entireVenue ||
            reservation?.bookingInfo?.meetingRooms > 0)
    ) {
        return true;
    }

    return false;
}
